import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrientationGameCoreService } from './orientation-game-core.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [OrientationGameCoreService],
})
export class OrientationGameCoreModule {}
